import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ibanFormatter' })
export class IbanFormatterPipe implements PipeTransform {

  transform(value: string | null | undefined, _args?: unknown): string {
    if ( value === null || value === undefined || value.trim().length === 0 ) {
      return '-';
    }

    const splitted = value.split('');
    let formatted = '';
    for ( let i = 0 ; i < splitted.length ; i++) {
      formatted += splitted[i];
      if (i % 4 === 3 ) {
        formatted += ' ';
      }
    }
    return formatted;
  }
}
